import {CampaignType, CampaignState} from '../../constants';

let storeKey = 'stCampaign';

let savedState = window.localStorage.getItem(storeKey) || '{}';
savedState = JSON.parse(savedState);


const state = Object.assign({}, {
   id: null, //current database campaign id (when fetched)
   type: CampaignType.MANUAL,
   executionState: CampaignState.CREATED,
   lastTimer: {
      state: null,
      duration: 0
   },
   timerDuration: 0,
   timerId: null,
}, savedState);


const mutations = {
   setViewTitle(state, title) {
      state.viewTitle = title;
   }

};

const actions = {
   setViewTitle: ({commit}, title) => {
      commit('setViewTitle', title);
   }
};


const getters = {
   stateCommands (state, getters) {
      let page = getters.currentPage;

      let pf = state.pageFilters.filter(f => f.page === page);
      if (pf && pf.length)
         return pf[0].filters;

      return null;
   },
}

export default {
   namespaced: true,
   state,
   mutations,
   actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/campaign.js